import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Button, Typography } from "@material-ui/core";
import ArrowDropDownOutlinedIcon from "@material-ui/icons/ArrowDropDownOutlined";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import WarningIcon from "@material-ui/icons/Warning";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import {
  useRouterContract1,
  useEthContract,
  useBscContract,
} from "./../../Hooks";
import ledu from "../../assets/token.webp";
import bsc from "../../assets/bnb-token-icon.png";
import eth from "../../assets/ethereum-icon.svg";

function RouterSwap({ setOpen, chain1, chain56, currentChainId }) {
  const { account } = useWeb3React();
  const [desValue, setDesValue] = useState();
  const [value, setValue] = useState();
  const [show, setShow] = useState(false);
  const [record, setRecord] = useState();
  const [desAddress, setDesAddress] = useState();
  const [tokenApproved, setTokenApproved] = useState(false);
  const RouterContract1 = useRouterContract1();
  const EthContract = useEthContract();
  const BscContract = useBscContract();
  const leduEth = "0xC741f06082AA47F93729070aD0dD95E223Bda091";
  const leduBsc = "0x887D9c01FFf04022da9c6D64a65a481a9e5D1FCa";

  useEffect(() => {
    if (currentChainId === 1) {
      setRecord(chain1);
    } else if (currentChainId === 56) {
      setRecord(chain56);
    }
  }, [currentChainId, chain56, chain1]);

  useEffect(() => {
    if (
      desValue &&
      chain1 &&
      currentChainId === 1 &&
      +desValue >= +chain1.MinimumSwapFee
    ) {
      setValue(desValue - chain1.MinimumSwapFee);
    } else if (desValue && chain56 && +desValue >= +chain56.MinimumSwapFee) {
      setValue(desValue - chain56.MinimumSwapFee);
    } else {
      setValue("");
    }
  }, [desValue, currentChainId]);

  const approveToken = async () => {
    if (!desValue) {
      toast.error("Please enter amount");
    } else {
      try {
        if (currentChainId === 1) {
          const tx = await EthContract.approve(account, desValue);
          await tx.wait();
          toast.success("Successfully approved!");
          setTokenApproved(true);
        } else {
          const tx = await BscContract.approve(account, desValue);
          await tx.wait();
          toast.success("Successfully approved!");
          setTokenApproved(true);
        }
      } catch (e) {
        setTokenApproved(false);
        console.log(e, "approve error");
      }
    }
  };

  const swapHandler = async () => {
    console.log(record.address, "contract");
    if (value && currentChainId && (account || desAddress)) {
      if (currentChainId === 1) {
        const tx = await RouterContract1.methods
          .anySwapOutUnderlying(
            leduEth,
            desAddress ? desAddress : account,
            desValue,
            currentChainId
          )
          .send({ from: account });
        await tx.wait();
        toast.success("Success!");
      } else if (currentChainId === 56) {
        const tx = await RouterContract1.methods
          .anySwapOutUnderlying(
            leduBsc,
            desAddress ? desAddress : account,
            desValue,
            currentChainId
          )
          .send({ from: account });
        await tx.wait();
        toast.success("Success!");
      }
    }
  };

  return (
    <Box py={8}>
      <Container maxWidth="md">
        <Box mb={4} fontSize={{ xs: "20px", sm: "24px" }} fontWeight={700}>
          Router
        </Box>
        <Box borderRadius="20px" bgcolor="rgba(255, 255, 255, 0.144)" p={5}>
          <Box display="flex" justifyContent="space-between" mb={3}>
            <Box fontSize="14px" color="#fff">
              From
            </Box>
            <Box fontSize="14px" color="#fff">
              Balance: 0.0
            </Box>
          </Box>

          <Grid
            container
            spacing={4}
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Grid item xs={12} sm={11} md={5}>
              <Box>
                <input
                  value={desValue}
                  onChange={(e) => {
                    if (
                      +e.target.value >= +chain1.MinimumSwap &&
                      currentChainId === 1
                    ) {
                      setDesValue(e.target.value);
                    } else if (
                      +e.target.value >= +chain56.MinimumSwap &&
                      currentChainId === 56
                    ) {
                      setDesValue(e.target.value);
                    } else {
                      setDesValue(e.target.value);
                    }
                  }}
                  type="number"
                  pattern="^[0-9]*[.,]?[0-9]*$"
                  placeholder={"0.0"}
                  spellCheck="false"
                  style={{
                    backgroundColor: "transparent",
                    outline: "none",
                    border: "none",
                    fontSize: "28px",
                    fontWight: 600,
                    width: "100%",
                    color: "#FFF",
                    flexBasis: 2,
                    paddingBottom: "5px",
                    borderBottom: "1px solid #fff",
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={11} md={7}>
              <Box display="flex">
                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid #fff",
                    padding: "13px 20px",
                    borderRadius: "14px",
                    marginRight: "20px",
                    "&:focus": {
                      borderColor: "silver",
                      boxShadow: " 0px 0px 23px 2px rgba(255, 255, 255, 0.144)",
                    },
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="40px"
                    height="40px"
                    bgcolor="#fff"
                    borderRadius="50%"
                    mr={1}
                  >
                    <img width="25px" src={ledu} alt="" />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    mb={1}
                  >
                    <Box fontSize="1rem" fontWeight={500}>
                      LEDU
                    </Box>
                    <Box lineHeight="1px" fontSize="14px" fontWeight={400}>
                      Education
                    </Box>
                  </Box>
                </Button>

                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid #fff",
                    padding: "13px 20px",
                    borderRadius: "14px",
                    "&:focus": {
                      borderColor: "silver",
                      boxShadow: " 0px 0px 23px 2px rgba(255, 255, 255, 0.144)",
                    },
                  }}
                  onClick={() => setOpen(true)}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="40px"
                    height="40px"
                    bgcolor="#fff"
                    borderRadius="50%"
                    mr={1}
                  >
                    <img
                      width="25px"
                      src={currentChainId === 1 ? eth : bsc}
                      alt=""
                    />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    mb={1}
                  >
                    <Box fontSize="1rem" fontWeight={500}>
                      {currentChainId === 1 ? "Ethereum" : "BSC"}
                    </Box>
                    <Box
                      lineHeight="1px"
                      fontSize="14px"
                      fontWeight={400}
                      style={{ textTransform: "lowercase" }}
                    >
                      mainnet
                    </Box>
                  </Box>

                  <Box
                    bgcolor="rgb(43, 43, 43)"
                    ml={4}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="30px"
                    height="30px"
                    borderRadius="50%"
                  >
                    <ArrowDropDownOutlinedIcon />
                  </Box>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Grid item container xs={12} style={{ margin: "30px 0px" }}>
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginLeft: "20px",
            }}
          >
            <Box
              bgcolor="rgb(43, 43, 43)"
              width="40px"
              height="40px"
              borderRadius="50%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <ArrowDownwardIcon
                sx={{
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{ "&:hover": { cursor: "pointer", color: "blue" } }}
              color="white"
              fontSize="20px"
              onClick={() => {
                show === true ? setShow(false) : setShow(true);
              }}
            >
              {show === true ? "-" : "+"} Send To
            </Typography>
          </Grid>
        </Grid>

        <Box borderRadius="20px" bgcolor="rgba(255, 255, 255, 0.144)" p={5}>
          <Box display="flex" justifyContent="space-between" mb={3}>
            <Box fontSize="14px" color="#fff">
              To
            </Box>
            <Box fontSize="14px" color="#fff">
              Balance: 0.0
            </Box>
          </Box>

          <Grid
            container
            spacing={4}
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Grid item xs={12} sm={11} md={5}>
              <Box>
                <input
                  value={value}
                  // universal input options
                  readOnly
                  inputMode="decimal"
                  title="Token Amount"
                  autoComplete="off"
                  autoCorrect="off"
                  // text-specific options
                  type="text"
                  pattern="^[0-9]*[.,]?[0-9]*$"
                  placeholder={"0.0"}
                  minLength={1}
                  maxLength={79}
                  spellCheck="false"
                  style={{
                    backgroundColor: "transparent",
                    outline: "none",
                    border: "none",
                    fontSize: "28px",
                    fontWight: 600,
                    width: "100%",
                    color: "#FFF",
                    flexBasis: 2,
                    paddingBottom: "5px",
                    borderBottom: "1px solid #fff",
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={11} md={7}>
              <Box display="flex">
                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid silver",
                    padding: "13px 20px",
                    borderRadius: "14px",
                    marginRight: "20px",
                    "&:hover": { border: "1px solid black" },
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="40px"
                    height="40px"
                    bgcolor="#fff"
                    borderRadius="50%"
                    mr={1}
                  >
                    <img width="25px" src={ledu} alt="" />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    mb={1}
                  >
                    <Box fontSize="1rem" fontWeight={500}>
                      LEDU
                    </Box>
                    <Box lineHeight="1px" fontSize="14px" fontWeight={400}>
                      Education
                    </Box>
                  </Box>
                </Button>

                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid silver",
                    padding: "13px 20px",
                    borderRadius: "14px",
                    "&:hover": { border: "1px solid black" },
                  }}
                  onClick={() => setOpen(true)}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="40px"
                    height="40px"
                    bgcolor="#fff"
                    borderRadius="50%"
                    mr={1}
                  >
                    <img
                      width="25px"
                      src={currentChainId === 1 ? bsc : eth}
                      alt=""
                    />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    mb={1}
                  >
                    <Box fontSize="1rem" fontWeight={600}>
                      {currentChainId === 1 ? "BSC" : "Ethereum"}
                    </Box>
                    <Box
                      lineHeight="1px"
                      fontSize="14px"
                      fontWeight={400}
                      style={{ textTransform: "lowercase" }}
                    >
                      mainnet
                    </Box>
                  </Box>

                  <Box
                    bgcolor="rgb(43, 43, 43)"
                    ml={4}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="30px"
                    height="30px"
                    borderRadius="50%"
                  >
                    <ArrowDropDownOutlinedIcon />
                  </Box>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box my={2}>
          <Grid
            item
            xs={12}
            style={{
              padding: "50px",
              backgroundColor: "#3E3E3E",
              borderRadius: "20px",
              display: show === true ? "block" : "none",
            }}
          >
            <Typography color="white">
              Recipient{" "}
              <span style={{ color: "red" }}>
                ( Please do NOT send funds to exchange wallet or custodial
                wallet. )
              </span>
            </Typography>
            <Box as={Link}>(View on BSC)</Box>
            <input
              placeholder="Wallet Address"
              className="input-field"
              type="text"
              value={desAddress}
              onChange={(e) => {
                setDesAddress(e.target.value);
              }}
            />
          </Grid>
        </Box>
        <Box my={2}>
          <Grid
            item
            xs={12}
            style={{
              padding: "20px",
              backgroundColor: "#3E3E3E",
              borderRadius: "20px",
            }}
          >
            <Box display="flex" justifyContent="space-between">
              <WarningIcon fontSize="large" />
              <Typography>
                This project is in beta. Use at your own risk.
              </Typography>
              <Button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  padding: "0px 20px",
                }}
              >
                Agree
              </Button>
            </Box>
          </Grid>
        </Box>

        <Grid
          item
          xs={12}
          style={{
            padding: "20px",
            backgroundColor: "#3E3E3E",
            borderRadius: "20px",
          }}
        >
          <Box
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
            alignItems="center"
          >
            <EmojiObjectsIcon fontSize="medium" />
            <Typography>Reminder:</Typography>
          </Box>
          <ul style={{ padding: "0px 30px" }}>
            <li>
              <Typography>
                Crosschain Fee is {record?.SwapFeeRatePerMillion}
                %, Minimum Crosschain Fee is {record?.MinimumSwapFee} LEDU,
                Maximum Crosschain Fee is {record?.MaximumSwapFee} LEDU
              </Typography>
            </li>
            <li>
              <Typography>
                Minimum Crosschain Amount is {record?.MinimumSwap} LEDU
              </Typography>
            </li>
            <li>
              <Typography>
                Maximum Crosschain Amount is {record?.MaximumSwap} LEDU
              </Typography>
            </li>
            <li>
              <Typography>
                Estimated Time of Crosschain Arrival is 10-30 min
              </Typography>
            </li>
            <li>
              <Typography>
                Crosschain amount larger than {record?.BigValueThreshold} LEDU
                could take up to 12 hours
              </Typography>
            </li>
          </ul>
        </Grid>
        {/* Action Button */}
        <Box my={4} display="flex" justifyContent="center">
          {account ? (
            <>
              <Button
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.144)",
                  borderRadius: "20px",
                  padding: "13px 0px",
                  width: "35%",
                  marginRight: "20px",
                }}
                onClick={approveToken}
              >
                Approve LEDU
              </Button>
              <Button
                disabled={tokenApproved}
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.144)",
                  borderRadius: "20px",
                  padding: "13px 0px",
                  width: "35%",
                  cursor: tokenApproved ? "pointer" : "not-allowed",
                }}
                onClick={swapHandler}
              >
                Swap
              </Button>
            </>
          ) : (
            <Button
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.144)",
                borderRadius: "20px",
                padding: "13px 0px",
                width: "35%",
              }}
              onClick={() => toast.error("Connect to your Wallet.")}
            >
              Connect to Wallet
            </Button>
          )}
        </Box>
      </Container>
    </Box>
  );
}

export default RouterSwap;
